// Theme-aware colours for ECharts (STRY0039116).
//
// Charts take literal colours, so they cannot use CSS variables directly. This
// reads the BugZero tokens off :root at call time; callers rebuild their option
// object on every render and already re-render when the theme flips (they read
// `isDark` from AppContext), so a switch applies without reload. `isDark` picks
// the fallback set when the tokens cannot be read (jsdom, very early paint).

const LIGHT = {
  bg: '#FFFFFF',
  ink: '#1A2530',
  inkSoft: '#425563',
  inkMuted: '#768692',
  line: '#E5E1DA',
  lineSoft: '#EFEBE3',
  empty: '#D8D4CE'
};

const DARK = {
  bg: '#1A252F',
  ink: '#E8EAED',
  inkSoft: '#B8C2CC',
  inkMuted: '#8A96A3',
  line: '#2C3A47',
  lineSoft: '#243140',
  empty: '#3A4A59'
};

// One computed-style read per call: dashboards render a chart per vendor,
// and each getComputedStyle on <html> can force a style flush.
const readTokens = names => {
  try {
    const cs = getComputedStyle(document.documentElement);
    return names.map(n => cs.getPropertyValue(n).trim());
  } catch (e) {
    return names.map(() => '');
  }
};

export const tok = name => readTokens([name])[0];

export const chartTheme = isDark => {
  const fallback = isDark ? DARK : LIGHT;
  const [bg, ink, inkSoft, inkMuted, line, lineSoft, empty] = readTokens([
    '--bg-elev',
    '--ink',
    '--ink-soft',
    '--ink-muted',
    '--line',
    '--line-soft',
    '--line-strong'
  ]);
  return {
    bg: bg || fallback.bg,
    ink: ink || fallback.ink,
    inkSoft: inkSoft || fallback.inkSoft,
    inkMuted: inkMuted || fallback.inkMuted,
    line: line || fallback.line,
    lineSoft: lineSoft || fallback.lineSoft,
    empty: empty || fallback.empty
  };
};

// Tooltip chrome shared by every chart: card background, ink text, line border.
export const chartTooltip = (t, extra = {}) => ({
  backgroundColor: t.bg,
  textStyle: { color: t.ink },
  borderColor: t.line,
  borderWidth: 1,
  ...extra
});
